export const debounce = <T extends (...args: any[]) => any>(callback: T, delay: number) => {
  let timeout: ReturnType<typeof setTimeout> | undefined;

  const run = (...args: Parameters<typeof callback>) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      callback(...args);
    }, delay);
  };

  run.cancel = () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }
  };

  return run;
};
